import { CONTACT, ASSETS } from "@/lib/contact";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="border-t border-chrome/15 bg-brand-black py-14 sm:py-20"
    >
      <div className="mx-auto grid max-w-[1400px] grid-cols-12 gap-8 px-5 sm:px-8">
        <div className="col-span-12 sm:col-span-5">
          <div className="flex items-center gap-3">
            <img
              src={ASSETS.logo}
              alt="GORILLAS REBOQUE"
              className="h-14 w-14 rounded-sm object-cover ring-1 ring-chrome/30"
              loading="lazy"
            />
            <div className="flex flex-col leading-none">
              <span className="font-display text-2xl tracking-widest text-white">
                GORILLAS
              </span>
              <span className="text-xs font-semibold tracking-[0.3em] text-brand-yellow">
                REBOQUE · 24H
              </span>
            </div>
          </div>
          <p className="mt-6 max-w-xs font-body text-sm leading-relaxed text-neutral-400">
            Guincho e reboque 24 horas em Belém, Ananindeua, Marituba e toda a
            Região Metropolitana. Atendimento rápido para carros, motos e
            caminhões.
          </p>
        </div>

        <div className="col-span-6 sm:col-span-3">
          <h4 className="font-mono text-[10px] tracking-[0.3em] text-brand-yellow">
            CONTATO
          </h4>
          <ul className="mt-5 flex flex-col gap-3 text-sm text-neutral-300">
            <li>
              <a
                data-testid="footer-phone"
                href={CONTACT.telHref}
                className="hover:text-brand-yellow"
              >
                {CONTACT.phoneDisplay}
              </a>
            </li>
            <li>
              <a
                data-testid="footer-email"
                href={`mailto:${CONTACT.email}`}
                className="hover:text-brand-yellow"
              >
                {CONTACT.email}
              </a>
            </li>
            <li className="text-neutral-500">Atendimento 24 horas</li>
          </ul>
        </div>

        <div className="col-span-6 sm:col-span-4">
          <h4 className="font-mono text-[10px] tracking-[0.3em] text-brand-yellow">
            ATENDIMENTO
          </h4>
          <ul className="mt-5 grid grid-cols-2 gap-x-4 gap-y-2 text-sm text-neutral-300">
            {[
              "Belém",
              "Ananindeua",
              "Marituba",
              "Benevides",
              "Castanhal",
              "Santa Izabel",
              "BR-316",
              "BR-010",
            ].map((c) => (
              <li key={c}>{c}</li>
            ))}
          </ul>
        </div>

        <div className="col-span-12 mt-8 flex flex-col items-start justify-between gap-2 border-t border-chrome/15 pt-6 text-[11px] uppercase tracking-[0.25em] text-neutral-500 sm:flex-row sm:items-center">
          <span data-testid="footer-copy">
            © {new Date().getFullYear()} GORILLAS REBOQUE · Belém / PA · Todos os
            direitos reservados
          </span>
          <span data-testid="footer-cnpj" className="text-neutral-600">
            CNPJ {CONTACT.cnpj}
          </span>
        </div>
      </div>
    </footer>
  );
}
